<template>
  <div
    id="advisor"
    class="advisor-container"
  >
    <div class="team-part-wrapper content-part-wrapper">
      <div class="team-title-wrapper content-title-wrapper">
        <h3>{{$t('ADVISOR')}}</h3>
        <span class="title-line"></span>
      </div>
      <div class="team-members-container">
        <div
            v-for="item in advisors"
            class="team-member"
            id="introduction"
        >

          <div class="team-member-content">
            <div class="team-member-name-position">
              <p class="team-member-name">{{item.name}}</p>
            </div>
            <p class="team-member-introduction">
              {{item.introduction}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "ADVISOR": "ADVISOR",
    "advisors": [
        {
          "name": "Binsheng Wang",
          "introduction": "Consultant of Blockchain Development Organization, professor at Graduate School of Chinese Academy of Social Sciences.",
          "picture": "../../assets/pagefounder/binsheng.jpeg"
        },
        {
          "name": "Coly Li",
          "introduction": "Linux Kernel Maintainer, former founder of Taobao kernel team.",
          "picture": "../../assets/pagefounder/coly.jpeg"
        }
      ]
  },
  "zn": {
    "ADVISOR": "顾问",
    "advisors": [
        {
          "name": "Binsheng Wang",
          "introduction": "区块链发展组织顾问，中国社会科学院研究生院教授。",
          "picture": "../../assets/pagefounder/binsheng.jpeg"
        },
        {
          "name": "Coly Li",
          "introduction": "Linux内核维护者，淘宝内核团队创始人。",
          "picture": "../../assets/pagefounder/coly.jpeg"
        }
      ]
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PcLogin",
  props: {},
  data() {
    return {
    };
  },
  computed: mapState({
     advisors() {
      return this.$t("advisors");
    },
    isZnWebsite: state => state.isZnWebsite,
  }),
  created() {
    this.$i18n.locale = this.isZnWebsite ? "zn": "en";
    if (this.isZnWebsite) {
      this.advisor = this.advisorZn;
    } else {
      this.advisor = this.advisorEn;
    }
  }
};
</script>

